import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  VaporThemeProvider,
  VaporPage,
  Title,
  Typography,
  Box,
  Spinner,
  TextField,
  Button,
  NotificationOverflow,
  AlertTitle,
} from "@vapor/v3-components";
import { TextEyePassword } from "../components/TextEyePassword";
import { login } from "../services/authService";
import { AuthResponse } from "../services/Models/AuthModel";
import { saveLogonInfoToCookies } from "../utils/util";
import { usePersistentState } from "../store/usePersistentState";
import { deleteLogonInfoFromCookies } from "../utils/util";
import { useTranslation } from "react-i18next";
import { useAuth } from "../Router/AuthProvider";
import { SiteParametersResponse } from "../services/Models/SiteParametersModel";
import { FilterListResponse } from "../services/Models/FilterListModel";
import { getFilterList } from "../services/filterListService";
import { localFilter } from "./Home";
import { CmsFilterDescriptorBase } from "../services/Models/FilterDescriptorModel";
import { returnError } from "../utils/util";

const TSID_Redirect: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation(); // Per accedere alla query string
  const navigate = useNavigate(); // Per navigare altrove se necessario
  const { performLogout, performLogin, isAuthenticated, redirectPath } =
    useAuth();
  const didRun = useRef(false);
  const redirectIpCode = useRef<number>(0);
  const redirectKey = useRef<string>("");
  const [spinner, setSpinner] = useState(true);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>("");
  const passwordInputRef = useRef<HTMLInputElement>(null); // Referenza per spostarsi al campo password
  const localSiteParameters = useRef<SiteParametersResponse>(
    JSON.parse(localStorage.getItem("SiteParameters") ?? "{}")
  );

  const [image, setImage] = usePersistentState("image", "");
  // const [state, setState] = useState<string | null>("");
  // const [code, setCode] = useState<string | null>("");
  // const [scope, setScope] = useState<string | null>("");
  // const [sessionState, setSessionState] = useState<string | null>("");
  // const [userName, setUsername] = useState<string | null>("");
  // const [securityToken, setSecurityToken] = useState<string | null>("");

  const verifyJwt = async (wCode: string, wState: string) => {
    let result: AuthResponse = await login(wCode, wState, -2);
    if (result.ResultCode === "ERROR") {
      // setState(result.DetailedMessage);
      // setCode("");
      // setScope("");
      // setSessionState("");
      // navigate("/logout", {
      //   state: { error: "true", description: "result.DetailedMessage" },
      // });
      performLogout({
        state: { error: "true", description: "result.DetailedMessage" },
      });
    } else {
      // setState("");
      // setCode("");
      // setScope("");
      // setSessionState("");
      // setUsername(result.UserLogin);
      // setSecurityToken(result.SecurityToken);
      if (result.UserLogin !== "") {
        if (!result.Language) result = { ...result, Language: "it" };
        else if (result.Language === "") result.Language = "it";
        saveLogonInfoToCookies({ ...result, rememberMe: false });
        localStorage.setItem("filterList", JSON.stringify([]));
        //        dispatch(setUser({ image: result.Image, userName: result.UserLogin }));
        setImage(window.config.BASE_URL + "/preview/" + result.Image);

        console.log("Login successful:", result.UserLogin);
        //        navigate("/home");
        callPage(result);
      } else {
        var list = result.SecurityToken.split("|"); // ipcode | key
        redirectIpCode.current = Number(list[0]);
        redirectKey.current = list[1];
        setSpinner(false);
      }
    }
  };

  const loadFilters = async (
    loginResult: AuthResponse,
    contPubFiltro: boolean
  ) => {
    setSpinner(true);
    try {
      const result: FilterListResponse = await getFilterList(
        loginResult.SecurityToken,
        loginResult.Language ?? "it",
        contPubFiltro
      );
      if (result && result.ResultCode !== "ERROR") {
        console.log("getFilter successful:");
        const locFilters: localFilter[] = result.Filters.map(
          (filter: CmsFilterDescriptorBase) => {
            const appFilter: localFilter = {
              filterId: filter.FilterId,
              filterName: filter.FilterName,
              IconFile: filter.IconFile,
              TotPub: filter.TotPub,
              LinkedDocs: filter.LinkedDocs === "1" ? true : false,
              noDownloadVideo:
                filter.DownloadVideo === "nodownload" ? true : false,
            };
            return appFilter;
          }
        );
        localStorage.setItem("filterList", JSON.stringify(locFilters));
        if (locFilters.length === 0) setError(t("noEnabledFilters"));
        else {
          if (redirectPath) {
            performLogin(redirectPath);
          } else {
            navigate(`/filter/${locFilters[0].filterId}`);
          }
        }
      } else {
        setError(t(returnError(result)));
        console.error("loadFilters Error :", "no result");
      }
    } catch (error) {
      setError(t("errore interno"));
      console.error("loadFilters Error :", error);
    } finally {
      setSpinner(false);
    }
  };

  const callPage = async (result: AuthResponse) => {
    if (redirectPath) {
      await loadFilters(result, localSiteParameters.current.ContPubFiltro);
    } else {
      performLogin();
      switch (localSiteParameters.current.Visualizzazione) {
        case "continuo":
          navigate("/presentationPage");
          break;
        case "tabs":
          await loadFilters(result, localSiteParameters.current.ContPubFiltro);
          break;
        default:
          navigate("/home");
      }
    }
  };
  useEffect(() => {
    if (!didRun.current) {
      didRun.current = true;
      // Analizza i parametri dall'URL
      const searchParams = new URLSearchParams(location.search);
      const wState = searchParams.get("state");
      const wCode = searchParams.get("code");
      const wScope = searchParams.get("scope");

      // setState(searchParams.get("state"));
      // setCode(searchParams.get("code"));
      // setScope(searchParams.get("scope"));
      // setSessionState(searchParams.get("session_state"));

      if (wCode && wScope && wScope === "openid profile" && wState) {
        verifyJwt(wCode, wState);
      } else {
        if (wState && wState === "logout") {
          deleteLogonInfoFromCookies();
          localStorage.removeItem("image");
          localStorage.removeItem("filterList");
          // navigate("/logout");
          performLogout();
        } else {
          // navigate("/logout", {
          //   state: { error: "true", description: "TSID Redirect error" },
          // });
          performLogout({
            state: { error: "true", description: "TSID Redirect error" },
          });
        }
      }
      // if (state && code) {
      //   console.log("State:", state);
      //   console.log("Code:", code);

      //   // navigate("/dashboard");
      // } else {
      //   console.error("Parametri mancanti nell'URL.");
      //   // Gestisci l'errore, ad esempio reindirizza a una pagina di errore
      //   navigate("/error");
      // }
    }
  }, [location, navigate]);

  const handleEnterPress = (
    event: React.KeyboardEvent<HTMLDivElement>,
    nextFieldRef?: React.RefObject<HTMLInputElement>
  ) => {
    if (event.key === "Enter") {
      event.preventDefault(); // Previene il comportamento predefinito
      if (nextFieldRef && nextFieldRef.current) {
        nextFieldRef.current.focus(); // Sposta il focus al campo successivo
      } else {
        handleLogin(); // Se non c'è un riferimento, esegue la funzione di login
      }
    }
  };

  const handleLogin = async () => {
    try {
      setError(null);
      let result: AuthResponse = await login(
        username,
        password,
        redirectIpCode.current,
        redirectKey.current
      );
      if (result.ResultCode === "ERROR") {
        setError(result.DetailedMessage);
        // dispatch(resetUser());
        setImage("");
        console.error("Login failed:", result.DetailedMessage);
      } else {
        if (!result.Language) result = { ...result, Language: "it" };
        else if (result.Language === "") result.Language = "it";
        saveLogonInfoToCookies({ ...result, rememberMe: false });
        localStorage.setItem("filterList", JSON.stringify([]));
        //        dispatch(setUser({ image: result.Image, userName: result.UserLogin }));
        setImage(window.config.BASE_URL + "/preview/" + result.Image);

        console.log("Login successful:", result.UserLogin);
        //        navigate("/home");
        callPage(result);
      }
      // Gestire la navigazione o il salvataggio del token
    } catch (error) {
      setError(t("errore interno"));
      // dispatch(resetUser());
      setImage("");
      console.error("Login failed:", error);
    }
  };

  return (
    <VaporThemeProvider>
      <VaporPage>
        {/* <Title title="Gestione Redirezione" /> */}
        <div>
          {/* <h1>state</h1>
          <p>{state}</p>
          <h1>code</h1>
          <p>{code}</p>
          <h1>scope</h1>
          <p>{scope}</p>
          <h1>sessionState</h1>
          <p>{sessionState}</p>
          <h1>userName</h1>
          <p>{userName}</p>
          <h1>securityToken</h1>
          <p>{securityToken}</p> */}
        </div>
        {!spinner && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
              backgroundColor: "#f5f5f5",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                width: "100%",
                maxWidth: 800,
                height: "100%",
                maxHeight: 580,
                minWidth: 100,
                minHeight: 100,
                display: "flex",
                flexDirection: "column",
                gap: 2,
                padding: 2,
                backgroundColor: "white",
                boxShadow: 3,
                borderRadius: 2,
              }}
            >
              <Title title={t("sso-associazione")} />
              {/* <Typography variant="bodyLargeHeavy" gutterBottom align="center">
                {t("sso-associazione-info")}
              </Typography> */}
              <TextField
                fullWidth
                variant="outlined"
                label={t("user-name-key")}
                id="user"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                onKeyDown={(e) => handleEnterPress(e, passwordInputRef)} // Premendo Enter va al campo successivo
                autoFocus
                sx={{
                  flexShrink: 0,
                  "& input:-webkit-autofill": {
                    boxShadow: "0 0 0 100px white inset",
                    WebkitTextFillColor: "#000",
                  },
                }}
                helperText={t("sso-associazione-info")}
              />
              <TextEyePassword
                fullWidth
                variant="outlined"
                id="password"
                label={t("password-key")}
                inputRef={passwordInputRef} // Riferimento per lo spostamento del focus
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={(e) => handleEnterPress(e)} // Corretto evento
                sx={{
                  "& input:-webkit-autofill": {
                    boxShadow: "0 0 0 100px white inset",
                    WebkitTextFillColor: "#000",
                  },
                }}
              />

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "left",
                  alignItems: "left",
                  flexDirection: "row",
                }}
              >
                <Button
                  variant="outlined"
                  color="primary"
                  sx={{ flexShrink: 0 }}
                  onClick={() => {
                    // navigate("/logout");
                    performLogout();
                  }}
                  size="medium"
                >
                  {t("cancel")}
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  sx={{ flexShrink: 0, marginLeft: "24px" }}
                  onClick={handleLogin}
                  size="medium"
                >
                  {t("login")}
                </Button>
              </Box>
              {error && (
                <NotificationOverflow
                  severity="error"
                  onClose={() => setError(null)}
                >
                  <AlertTitle>{t("error-header")}</AlertTitle>
                  {error}
                </NotificationOverflow>
              )}
            </Box>
          </Box>
        )}
        {spinner && (
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgba(255, 255, 255, 0.8)", // Sfondo semitrasparente opzionale
            }}
          >
            <Spinner size={64} />
          </Box>
        )}
      </VaporPage>
    </VaporThemeProvider>
  );
};

export default TSID_Redirect;
